module.exports = __webpack_public_path__ + "img/file-88.b2ea6ab2.png";